import { NO_DATA } from 'consts';

export const locationAndSubLocationCondition = (valuesFromSearchBar) => {
  if (valuesFromSearchBar.some((filter) => filter.optionid === 'locationName' || filter.id === 'locationId')
    && valuesFromSearchBar.some((filter) => filter.optionid === 'sublocationName' || filter.id === 'sublocationId')) {
    const arr = valuesFromSearchBar.filter((value) => value.optionid !== 'locationName' && value.id !== 'locationId');
    return arr;
  }
  return valuesFromSearchBar;
};

export const defaultMaxDate = (epoch) => epoch.moment.tz(epoch.currentTimeZone);

export const mapOptions = (arr) => arr.map(({ name, ecId }) => ({
  label: name ?? NO_DATA,
  value: ecId ?? NO_DATA,
  id: ecId ?? NO_DATA,
}));
